<div (click)="openDialog()" class="user-info" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
  <div class="btn-cursor" fxLayout="column">
    <span class="body-1-regular-1">{{loggedInUserName}}</span>
    <span class="body-3-default">{{currentRetailerName}}</span>
  </div>
</div>
